import { createAsyncThunk } from '@reduxjs/toolkit';

import type { SavingsInsightsSummaryDto } from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsSummaryParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
}

export const fetchSavingsSummary = createAsyncThunk<
    SavingsInsightsSummaryDto,
    FetchSavingsSummaryParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsSummary',
    async ({ dateFrom, dateTo, propertyIds, categoryIds }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const params: Record<string, string> = {
                date_from: dateFrom,
                date_to: dateTo,
            };
            if (propertyIds?.length) {
                params.property_ids = propertyIds.join(',');
            }
            if (categoryIds?.length) {
                params.category_ids = categoryIds.join(',');
            }
            const response = await extra.api.get<SavingsInsightsSummaryDto>(
                '/v1/reports/savings-insights/summary',
                { params },
            );
            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
